<template>
  <div class="slider-container">
    <div class="slider-wrapper" :style="sliderStyle">
      <div v-for="(slide, index) in slides" :key="slide.id" class="slide" :class="{ 'active': currentIndex === index }">
        <img  :src="isMobile ? slide.mobileImage : slide.image">
        <!-- <div class="slide-content">
          <h3>{{ $t(slide.title) }}</h3>
          <p>{{ $t(slide.text) }}</p>
        </div> -->
      </div>
    </div>

    <!-- <div class="dots">
      <router-link :to="slide.url" v-for="(slide, index) in slides" :key="index" class="dot-item" :class="{ 'active': currentIndex === index }"
        @mouseenter="goToSlide(index)" >
        <div class="dot-item-img">
          <img :src="slide.logo" :alt="slide.alt">
        </div>
        <a href="">{{$t(slide.more)}}</a>
     
      </router-link>
    </div> -->
  </div>
</template>

<script>
// import FloatingHand from '@/components/FloatingHand.vue'
export default {
  components:{
    // FloatingHand
  },
  data() {
    return {
      isMobile:false,
      currentIndex: 0,
      slides: [
      {
        id: 1,
        image: require('@/assets/index/1.jpg'),
        mobileImage:require('@/assets/index/1.jpg'),
        alt: 'Slide 1',
        title: 'slide1.title', // 使用国际化键值
        text: 'slide1.text',
        more: 'slide1.more',
        logo: require('@/assets/daimin/岱民logo.png'),
        url: '/daimin'
      },
      {
        id: 2,
        image: require('@/assets/index/2.png'),
        mobileImage:require('@/assets/index/2.png'),
        alt: 'Slide 2',
        title: 'slide2.title',
        text: 'slide2.text',
        more: 'slide2.more',
        logo: require("@/assets/tangyuan/tangyuan.png"),
        url: '/TY'
      },
      {
        id: 3,
        image: require('@/assets/index/3.png'),
        mobileImage:require('@/assets/index/3.png'),
        alt: 'Slide 3',
        title: 'slide3.title',
        text: 'slide3.text',
        more: 'slide3.more',
        logo: require('@/assets/zfz/紫分子logo.png'),
        url: '/Zfz'
      }
    ],
    autoplayInterval: null
    }
  },
  computed: {
    sliderStyle() {
      return {
        transform: `translateX(-${this.currentIndex * 100}%)`
      }
    }
  },
  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
    },
    prev() {
      this.currentIndex = this.currentIndex === 0
        ? this.slides.length - 1
        : this.currentIndex - 1
    },
    goToSlide(index) {
      this.currentIndex = index
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.next()
      }, 5000)
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval)
    },
    checkIsMobile() {
    this.isMobile = window.innerWidth <= 940;
  }
  },
  mounted() {
    this.startAutoplay()
    this.checkIsMobile()
  },
  beforeUnmount() {
    this.stopAutoplay()
   
  },

}
</script>

<style scoped>
.slider-container {
  width: 88%;
  margin: 0 auto;
  margin-top: 5%;
  overflow: hidden;
}

.slider-wrapper {
  display: flex;
  width: 100%;
}

.slide {
  flex: 0 0 100%;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide img {
  width: 78%;
  height: auto;   /* 最关键：保持原始比例 */
  display: block;
}



.slide-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  width: 90%;
}

.slide-content h3 {
  font-size: 3vw;
  margin-bottom: 1rem;
  color: #fff;
  font-weight: 700;
}

.slide-content p {
  font-size: 2vw;
  margin-bottom: 2rem;
  color: #fff;
  font-weight: 700;
}


.nav-button.prev {
  left: 20px;
}

.nav-button.next {
  right: 20px;
}

.dots {
  width: 70%;
  position: relative;
  display: flex;
  gap: 4vw;
  justify-content: center;
  top: -8vw;
  left: 50%;
  transform: translateX(-50%);
}
.dots a{
  padding-top: .8vw;
  font-size: .7vw;
}

.dot-item-line {
  border-bottom: 2px solid #d01814;
  width: 88%;
  margin: .5vw 0;
}

.dot-item {
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 2vw;
  box-shadow: .5vw .5vw 1vw 0 rgba(0, 0, 0, 0.5);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1vw;
  transition: transform 0.3s ease;
  width: 11vw;
}

.dot-item:hover {
  transform: translateY(-10px);
  
}

.dot-item.active {
  opacity: 1;
}

.dot-item-img{
  padding-top: .5vw;
}
.dot-item-img img {
  height: 6vw;
  object-fit: contain;
}
.dot-content a {
  padding: 0 .8vw;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: .8vw;
  padding: 0 1vw;
}
.dot-content a:hover {
  text-decoration: none;
}


.dot-item-text {
  color: white;
  font-size: 12px;
  margin-top: 5px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (max-width: 940px) {
  .slider-container {
  letter-spacing: .1vw;
  position: relative;
  width: 88%; /* 容器宽度 100% */
  height: 50vw; /* 高度根据需求进行调整 */
  overflow: hidden;
  margin: 0 auto; /* 水平居中容器 */
  margin-top: 5%;
}
  .slide-content h3 {
    font-size: 6vw;
  }

  .slide-content p {
    font-size: 5vw;
  }

  .slide-content a {
    font-size: 4vw;
  }

  .slide {
  width: 100%;
  height: 100%; /* 根据实际需求调整 */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
  .slide img {
  width: 100%;
    height: auto;
  object-fit: cover; /* 保持图片比例，铺满裁剪 */
}

  .dots {
    display: none;
    gap: 1vw;
    padding: .5vw;
 
  }
  .dot-item-img img {
    
    height: 5vw;
  }

  .dot-content a {
    font-size: 1.4vw;
    padding: 0 1vw;
  }
}
</style>